var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 4.526c-6.545 0-11.85 5.306-11.85 11.85 0 6.545 5.305 11.85 11.85 11.85 2.966 0 5.678-1.09 7.757-2.89l3.642 3.642a.85.85 0 0 0 1.202-1.203l-3.642-3.642a11.804 11.804 0 0 0 2.891-7.757c0-6.544-5.306-11.85-11.85-11.85ZM6.35 16.376c0-5.605 4.544-10.15 10.15-10.15 5.606 0 10.15 4.545 10.15 10.15 0 5.606-4.544 10.15-10.15 10.15-5.606 0-10.15-4.544-10.15-10.15Zm10.15 7a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z"
  })));
};
export default SvgSearch;